.ux-iws-interactive-tiles {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    align-self: stretch;

    @media only screen and (min-width: 1024px) {
        flex-direction: row;
    }

    &__background-placeholder {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        padding: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        padding: 0;

        &--l {
            background-size: cover;
            background-position: center;
            display: block;
        }
    }

    &--content-centered {
        @media only screen and (min-width: 1024px) {
            text-align: center;
        }
    }

    &--content-centered .ux-iws-interactive-tile__number-container {
        @media only screen and (min-width: 1024px) {
            margin: 0 auto 15px;
        }
    }

    &--content-centered .ux-iws-interactive-tile__icon-container {
        @media only screen and (min-width: 1024px) {
            margin: 0 auto 25px;
        }
    }
}
